import { render, staticRenderFns } from "./mi-ju-shi-chan.vue?vue&type=template&id=53a96540&scoped=true"
import script from "./mi-ju-shi-chan.vue?vue&type=script&lang=js"
export * from "./mi-ju-shi-chan.vue?vue&type=script&lang=js"
import style0 from "./mi-ju-shi-chan.vue?vue&type=style&index=0&id=53a96540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_00c06ca9196352b30e67b45b8b60d79f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a96540",
  null
  
)

export default component.exports